module.exports = __webpack_public_path__ + "static/media/overdue-ar.c4736429.svg";